import { Grid, makeStyles, Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Collapse, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import { useAPI } from "../../../common/API";
import DeterminateLinearProgress from "../../../utils/DeterminateLinearProgress";
import ArrowDropUpOutlinedIcon from '@material-ui/icons/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import clsx from "clsx";
import {useAuth} from "../../../common/auth";

const useEmailRuleStyles = makeStyles((theme) => ({
    disabled: {
        backgroundColor: theme.palette.action.hover,
    },
    root: {
        transition: theme.transitions.create("background-color", {
            duration: "300ms",
        }),
        marginBottom: 15,
    },
    row: {
        paddingLeft: 15,
        paddingRight: 15,
        marginBottom: 10,
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    toolbar: {
        paddingLeft: 15,
        paddingRight: 15,
    },
    header: {
        cursor: 'pointer',
    },
}));

export default function AccountSettings(props) {
    const api = useAPI();
    const auth = useAuth();
    const classes = useEmailRuleStyles();
    const respStatus = props.respStatus;
    const [sendingReq, setSendingReq] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [deletionReason, setDeletionReason] = useState('');

    useEffect(() => {
        if (respStatus) {
            setSendingReq(false);
            props.setRespStatus(null);
        }
    }, [respStatus]);

    const handleDeleteAccount = () => {
        setSendingReq(true);
        api.destroy(`api/v1/auth/user/delete/`, {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                deletion_reason: deletionReason,
            }),
        })
            .then((res) => {
                if (res.ok) {
                    auth.signOut().then(() => {
                        window.location.href = '/sign-in';
                    });
                }
            })
            .catch((error) => {
                console.error('Error deleting account:', error);
                setSendingReq(false);
            });
    };

    const handleOpen = () => {
        setOpenSettings(!openSettings);
    };

    const handleCloseDialog = () => {
        setDeleteDialogOpen(false);
        setDeletionReason('');
    };

    return (
        <Paper className={clsx(classes.root, !openSettings && classes.disabled)}>
            <DeterminateLinearProgress visible={sendingReq} opened={openSettings} />
            <Toolbar className={classes.toolbar} onClick={handleOpen}>
                <Grid className={classes.header} container direction="row" justify="space-between" component="label">
                    <Grid item>
                        <Typography variant="h6" component="div">
                            Account Settings
                        </Typography>
                    </Grid>
                    <Grid item>
                        {!openSettings ? (
                            <ArrowDropDownOutlinedIcon fontVariant="outlined" color="primary" fontSize="large" onClick={handleOpen} />
                        ) : (
                            <ArrowDropUpOutlinedIcon fontVariant="outlined" color="primary" fontSize="large" onClick={handleOpen} />
                        )}
                    </Grid>
                </Grid>
            </Toolbar>
            <Collapse in={openSettings}>
                <Grid container direction="row" spacing={3} justify="space-around" className={classes.row}>
                    <Grid item xs={12}>
                        <Typography variant="body2" style={{ marginBottom: '10px' }}>
                            Warning: Your account and all associated data will be permanently deleted within 30 days.
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => setDeleteDialogOpen(true)}
                            disabled={sendingReq}
                        >
                            Delete Account
                        </Button>
                    </Grid>
                </Grid>
            </Collapse>

            <Dialog
                open={deleteDialogOpen}
                onClose={handleCloseDialog}
                aria-labelledby="delete-account-dialog"
            >
                <DialogTitle id="delete-account-dialog">Confirm Account Deletion</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete your account? This action cannot be undone.
                        Your account and all associated data will be permanently deleted within 30 days.
                    </Typography>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="deletion-reason"
                        label="Reason for deletion (optional)"
                        type="text"
                        fullWidth
                        multiline
                        rows={4}
                        value={deletionReason}
                        onChange={(e) => setDeletionReason(e.target.value)}
                        variant="outlined"
                        style={{ marginTop: '20px' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteAccount} color="secondary" autoFocus>
                        Delete Account
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
}
